import { useState } from "react";
import { CreditCard } from "lucide-react";
import { Card, CardContent } from "../../../../../components/ui/card";
import { Button } from "../../../../../components/ui/button";
import { ConfirmDialog } from "../../../../../components/ui/confirm-dialog";
import { formatDateBR } from "../../../../../utils/format-utils";

interface StatBoxPaymentRequestProps {
  title: string;
  value: number;
  ops: string;
  dateToCheckout: string;
  onRequestPayment: (ops: string, dateToCheckout: string) => void;
  isDisabled: boolean;
}

export function StatBoxPaymentRequest({
  title,
  value,
  ops,
  dateToCheckout,
  onRequestPayment,
  isDisabled,
}: StatBoxPaymentRequestProps) {
  const [confirmDialogOpen, setConfirmDialogOpen] = useState(false);

  const formatValue = (val: number) => {
    return new Intl.NumberFormat("pt-BR", {
      style: "currency",
      currency: "BRL",
    }).format(val / 100);
  };

  const handleConfirm = () => {
    onRequestPayment(ops, dateToCheckout);
  };

  return (
    <>
      <Card className="min-h-[140px] col-span-5">
        <CardContent className="p-6 flex flex-col justify-between h-full">
          <div className="flex items-start justify-between mb-4">
            <div className="flex-1">
              <p className="text-sm font-medium text-muted-foreground mb-2">
                {title}
              </p>
              <p className="text-2xl font-bold text-foreground">
                {formatValue(value)}
              </p>
            </div>
            <div className="ml-4 flex-shrink-0">
              <CreditCard className="h-6 w-6 text-primary" />
            </div>
          </div>

          <Button
            onClick={() => setConfirmDialogOpen(true)}
            disabled={isDisabled}
            className="w-full"
          >
            <CreditCard className="mr-2 h-4 w-4" />
            SOLICITAR PAGAMENTO
          </Button>
        </CardContent>
      </Card>

      <ConfirmDialog
        open={confirmDialogOpen}
        onOpenChange={setConfirmDialogOpen}
        onConfirm={handleConfirm}
        title="Confirmar Solicitação de Pagamento"
        confirmText="Confirmar"
        cancelText="Cancelar"
      >
        <div className="space-y-2">
          <p>
            Tem certeza que deseja solicitar pagamentos para a operação{" "}
            <strong>{ops}</strong>?
          </p>
          <div className="mt-4 space-y-1">
            <p>
              <strong>Valor:</strong> {formatValue(value)}
            </p>
            <p>
              <strong>Data:</strong>{" "}
              {dateToCheckout ? formatDateBR(dateToCheckout) : "N/A"}
            </p>
          </div>
        </div>
      </ConfirmDialog>
    </>
  );
}
